import axios from 'axios'
import sessionService from '@/services/sessionService.js';
import { cacheAdapterEnhancer, throttleAdapterEnhancer } from 'axios-extensions'; 
import { getCookie, globalErrors } from '@/utils/index.js';

import { createToaster } from "@/utils/plugins/toaster";
const toaster = createToaster({position: "top", maxToasts: 1});

const API_URL = window.rmsBasePath ? window.rmsBasePath : '/';

const HTTP = axios.create({
    baseURL: API_URL,
    withCredentials: true,
    // timeout: 5000,
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    adapter: throttleAdapterEnhancer(cacheAdapterEnhancer(axios.defaults.adapter, { enabledByDefault: true }))
});

// const pendingRequests = window.pendingRequests = {};

HTTP.defaults.xsrfCookieName = getCookie('RMS-XSRF-TOKEN')
    ? 'RMS-XSRF-TOKEN'
    : 'XSRF-TOKEN';

HTTP.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

// HTTP.interceptors.request.use(req =>{
//     let spa_ver = localStorage.getItem('spa_version');
//     if(spa_ver) req.headers['X-SPA-VERSION'] = spa_ver;

//     if(req.method === 'get' && !req.skipPendingList && req.responseType !== 'blob'){
//         const cancelTokenSource = axios.CancelToken.source();
    
//         req.cancelToken = cancelTokenSource.token;
//         req.cancelSource = cancelTokenSource;
//         if(pendingRequests[req.url] && !req.ignoreCancel) {
//             pendingRequests[req.url].cancelSource.cancel('Canceled for new request with same URL');
//         }
//         pendingRequests[req.url] = req;
//     }
    
//     return req;
// });

HTTP.interceptors.response.use(function (response) {
//     delete pendingRequests[response.config.url];
    return response;
}, async function (error) {

//     delete pendingRequests[error?.response?.config?.url];

    if(error?.response?.data?.errors && error?.response?.data?.errors[0]?.code == 'API_READ_ONLY_MODE') {
        toaster.show(error?.response?.data?.errors[0]?.message || 'The API is currently in read-only mode due to system maintenance. Write operations are temporarily disabled.');
        return Promise.reject(error.response);
    }

    if (error?.response?.status === 401) {
        const url = error.response?.config?.url;

        if(url == '/sign-in') {
            return Promise.reject(error.response);
        } else {
            window.location.replace('/');
        }
//         if(url === '/user' && remoteLocations.includes(window.location.pathname)){
//             return Promise.reject(error.response);
//         }
//         if (url && url.includes(import.meta.env.VUE_APP_AUTH_URL)) {
//             return Promise.reject(error.response);
//         }
//         if(sessionService.isAuthenticated){
            // await sessionService.refreshToken(error.config);

   
//         }
    }
    if(error?.response?.data?.errors && globalErrors.includes(error?.response?.data?.errors[0]?.code)){
        sessionService?.globalError(error?.response?.data?.errors[0]);
        return Promise.reject(error.response);
    }

    return Promise.reject(error?.response || error);
    
});

export default HTTP;